import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './styles/theme';
import Layout from './components/layout/Layout';
import Seo from './components/Seo';

// Import all page components
import Home from './pages/Home';
import About from './pages/About';
import Admissions from './pages/Admissions';
import Academics from './pages/Academics';
import Homeschool from './pages/Homeschool';
import WhyThisSchool from './pages/WhyThisSchool';
import OpenHouse from './pages/OpenHouse';
import AdmissionInquiry from './pages/AdmissionInquiry';
import HomeworkSupport from './pages/HomeworkSupport';
import Resources from './pages/Resources';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter basename="/">
        <Seo />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/homeschool" element={<Homeschool />} />
            <Route path="/why-this-school" element={<WhyThisSchool />} />
            <Route path="/open-house" element={<OpenHouse />} />
            <Route path="/admission-inquiry" element={<AdmissionInquiry />} />
            <Route path="/homework-support" element={<HomeworkSupport />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
